'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image, ImageBackground} from 'react-native';
import BaseInfo from '../../baseInfo';
import styles from './style';
import QImageSet from '../../../../../assets/QImageSet';

class RankCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            labelItem, depCity, arrCity, depDate, depWeekDay,
            backDate, backWeekDay, discount, price, travelType, index
        } = this.props.data;

        return (
            <TouchableOpacity  key={depDate + index} onPress={()=>{this.props.jump(this.props.data)}} style={styles.cheapRankItem}>
                <View style={styles.cheapRankItemBgColor} />
                <ImageBackground source={{uri: QImageSet.discount_bg}}  style={styles.cheapRankItemBg} />
                {
                    labelItem && (
                        <View style={[styles.label, {backgroundColor: labelItem.bgColor}]}>
                            <Image source={{ uri: labelItem.image }} style={styles.labelImg} />
                            <Text
                                style={[styles.labelText, {color: labelItem.textColor}]}>{labelItem.text}</Text>
                        </View>
                    )
                }

                <View style={styles.cheapInfo}>
                    <View style={styles.rankField}>
                        {index + 1 > 3
                            ? <Text style={styles.rankText}>{index + 1}</Text>
                            : <Image style={styles.rankImage} source={{uri: QImageSet[`modal${index + 1}`]}}/>
                        }


                    </View>
                    <BaseInfo
                        data={this.props.data}
                        index={index}
                        config={{
                            isRank: true,
                            subTitleTop: 4,
                            baseInfoStyle: styles.rankBaseInfo,
                            baseInfoTextStyle: index < 3 ? styles.cheapCityText : {},
                            iconColor: index < 3 ? '#FF6600': '#333'
                        }}/>

                </View>
                <View style={styles.rankPriceField}>
                    <Text style={styles.priceDiscount}>{discount}</Text>
                    <View style={styles.accuratePriceField}>
                        <Text style={[styles.priceColor, styles.rankPrefixSize]}>&yen;</Text>
                        <Text style={[styles.priceColor, styles.rankYuanSize]}>{price}</Text>
                    </View>
                </View>
            </TouchableOpacity>
        )
    }
}

export default RankCard;
